import { render } from "./Chat.vue?vue&type=template&id=d3dbd13e&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=ts"
export * from "./Chat.vue?vue&type=script&lang=ts"

import "./Chat.vue?vue&type=style&index=0&id=d3dbd13e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d3dbd13e"

export default script